export enum DroppableZones {
  PRODUCT_BANK_CONNECTED_INPUTS = 'PRODUCT_BANK_CONNECTED_INPUTS',
  PRODUCT_BANK_FREE_INPUTS = 'PRODUCT_BANK_FREE_INPUTS',
}
